import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import {updateIsCurrentChoose} from '@redux/vocabulary/vocabulary'
import {useDispatch, useSelector} from 'react-redux'
import Volume from '@assets/svgs/learn/volume_3.svg'
import useVocabulary from './useVocabulary'
import WrongAudio from '@assets/audios/wrong.mp3'
import RightAudio from '@assets/audios/right.mp3'
import {useEffect, useState} from 'react'
import {randomElementIndexInArray} from '@utils'

const ChooseAnswer = ({currentVocabulary}: {currentVocabulary: any}) => {
  const {currentChoose} = useSelector((state: any) => state.vocabulary)
  const [choices, setChoices] = useState<any>()
  const dispatch = useDispatch()
  const {handlePlayAudio, handlePauseAudio} = useVocabulary()

  useEffect(() => {
    if (!currentVocabulary?.vocabularyQuestionData?.answers) return
    setChoices(
      randomElementIndexInArray(
        currentVocabulary?.vocabularyQuestionData?.answers,
      ),
    )
  }, [currentVocabulary])

  useEffect(() => {
    setTimeout(() => {
      handlePlayAudio(currentVocabulary?.vocabularyQuestionData.audio)
    }, 500)

    return () => handlePauseAudio()
  }, [currentVocabulary])

  const handleClickItem = (item: any) => {
    if (currentChoose) {
      return
    }
    if (item.is_true_answer) {
      handlePlayAudio(RightAudio)
    } else {
      handlePlayAudio(WrongAudio)
    }
    dispatch(updateIsCurrentChoose(item))
  }

  return (
    <Box h={'100%'}>
      <Center flexDirection={'column'} pt={'20px'}>
        <Text fontSize={'18px'} color={'#1890FF'}>
          {currentVocabulary?.vocabularyQuestionData.title}
        </Text>
        <Flex gap={'16px'} alignItems={'center'} mt={'40px'}>
          <Image
            cursor={'pointer'}
            src={Volume}
            onClick={() =>
              handlePlayAudio(currentVocabulary?.vocabularyQuestionData.audio)
            }
          />
          <Text fontSize={{base: '20px', md: '24px'}} fontWeight={600}>
            {currentVocabulary?.vocabularyQuestionData.question}
          </Text>
        </Flex>
        <Flex mt={'40px'} gap={'20px'} w={'100%'} px={'20px'}>
          {choices?.map((item: any, index: any) => (
            <Center
              key={index}
              cursor={'pointer'}
              h={'96px'}
              borderRadius={'16px'}
              flex={1}
              border={'3px solid #F0F0F0'}
              borderColor={
                currentChoose?.text_en === item.text_en
                  ? currentChoose?.is_true_answer
                    ? '#73D13D'
                    : '#FF4D4F'
                  : '#F0F0F0'
              }
              bg={
                currentChoose?.text_en === item.text_en
                  ? currentChoose?.is_true_answer
                    ? '#F6FFED'
                    : ''
                  : ''
              }
              onClick={() => handleClickItem(item)}>
              <Text
                fontSize={'24px'}
                color={
                  currentChoose?.text_en === item.text_en
                    ? currentChoose?.is_true_answer
                      ? '#73D13D'
                      : '#FF4D4F'
                    : ''
                }>
                {item.text_en}
              </Text>
            </Center>
          ))}
        </Flex>
      </Center>
    </Box>
  )
}

export default ChooseAnswer
